import React, { useContext } from 'react'
import { ConfirmationDialog } from '../../uiComponents/popups/confirmationDialog'
import { ProductTableActionKind, productTableContext } from './provider'
import { getProductName } from './utils'
import { useDuplicateProductMutation } from '../reduxApi'
import { useParams } from 'react-router-dom'
import { BaseRouteParams } from '../../hocs'
import { showWarningMessage } from 'uiComponents/message'
import { useTranslation, Trans } from 'translations'

const DuplicateProduct = () => {
    const { t } = useTranslation()
    const { accountSlug } = useParams<BaseRouteParams>()
    const { state, dispatch: productTableDispatch } = useContext(productTableContext)
    const [duplicateProduct] = useDuplicateProductMutation()
    const closeModal = () =>
        productTableDispatch({ type: ProductTableActionKind.SET_PRODUCT_FOR_DUPLICATING, payload: undefined })
    const onConfirm = async () => {
        const copyId = await duplicateProduct({ uuid: state.selectProductToDuplicate?.id as string }).unwrap()
        showWarningMessage(
            t('products.productTable.duplicate.copyWarning', {
                name: getProductName(state?.selectProductToDuplicate?.name),
            }),
            'duplicate_product_warning',
        )

        closeModal()
        window.open(`/account/${accountSlug}/products/crud/${copyId}${location.search}`, '_blank')
    }

    if (!state.selectProductToDuplicate) {
        return null
    }

    return (
        <ConfirmationDialog
            title={t('products.productTable.duplicate.title')}
            buttonText={t('products.productTable.duplicate.button')}
            onConfirm={onConfirm}
            onCancel={closeModal}
            text={
                <span>
                    <Trans
                        i18nKey="products.productTable.duplicate.text"
                        values={{ name: getProductName(state.selectProductToDuplicate.name) }}
                        components={{ b: <b /> }}
                    />
                </span>
            }
        />
    )
}

export default DuplicateProduct
